import React from 'react';
import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

import ConfigurableEnumModal from './form/modal';
import ConfigurableEnumDeleteModal from './form/delete_modal';

export class ConfigurableEnumRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    basePath: PropTypes.string.isRequired,
    enumValue: PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      static: PropTypes.bool.isRequired
    }).isRequired,
    enumValues: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      static: PropTypes.bool.isRequired
    })).isRequired,
    modalText: PropTypes.shape({
      formLabel: PropTypes.string,
      title: PropTypes.string
    }),
    onRemove: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  static defaultProps = {
    modalText: { formLabel: 'Label', title: 'Value' }
  }

  state = {
    showModal: false,
    showDeleteModal: false
  }

  showModal = () => {
    this.setState({ showModal: true });
  }

  hideModal = () => {
    this.setState({ showModal: false });
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  }

  hideDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  }

  handleDelete = () => {
    const { enumValue } = this.props;
    this.props.onRemove(enumValue);
    this.hideDeleteModal();
  }

  handleSave = (savedEnumValue) => {
    this.hideModal();
    this.props.onSave(savedEnumValue);
  }

  addStaticEnumTooltip(span, name) {
    return (
      <OverlayTrigger
        id={`${name}-${this.props.enumValue.id}`}
        overlay={
          <Tooltip id={`${name}-tooltip-${this.props.enumValue.id}`}>
            This is a Buildout default value and cannot be changed
          </Tooltip>
        }
        placement="top"
      >
        {span}
      </OverlayTrigger>
    );
  }

  renderDragSource() {
    return this.props.connectDragSource(
      <span className="clickable">
        <FontAwesomeIcon className="me-4 text-muted" icon={faEllipsisV} />
      </span>
    );
  }

  renderCTAs() {
    const isStatic = this.props.enumValue.static;
    const span = (
      <span>
        <span
          className={`me-2 ${isStatic ? 'text-muted' : 'text-primary clickable'}`}
          name="edit-enum-value"
          onClick={isStatic ? null : this.showModal}
        >
          <FontAwesomeIcon icon={faPencilAlt} /> Edit
        </span>
        <span
          className={`${isStatic ? 'text-muted' : 'text-danger clickable'}`}
          name="remove-enum-value"
          onClick={isStatic ? null : this.showDeleteModal}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </span>
      </span>
    );

    return (
      <div>
        {isStatic ? this.addStaticEnumTooltip(span, "actions") : span}
      </div>
    );
  }

  render() {
    const { enumValue, enumValues, basePath, modalText } = this.props;
    const { showModal, showDeleteModal } = this.state;

    const style = {
      opacity: this.props.isDragging ? 0 : 1
    };


    return this.props.connectDragPreview(this.props.connectDropTarget(
      <li className="list-group-item" name="value-row" style={style}>
        <Row className="w-100 gx-0">
          <Col xs={9}>
            {this.renderDragSource()}
            {enumValue.label}
          </Col>
          <Col className="text-end" xs={3}>
            {this.renderCTAs()}
          </Col>
        </Row>

        <ConfigurableEnumModal
          basePath={basePath}
          enumValue={enumValue}
          formLabel={modalText.formLabel}
          modalTitle={modalText.title}
          show={showModal}
          onCancel={this.hideModal}
          onSave={this.handleSave}
        />

        <ConfigurableEnumDeleteModal
          basePath={basePath}
          enumValue={enumValue}
          enumValues={enumValues}
          formLabel={modalText.formLabel}
          show={showDeleteModal}
          onCancel={this.hideDeleteModal}
          onDelete={this.handleDelete}
        />
      </li>
    ));
  }
}

export default reorderableListItem(ConfigurableEnumRow, "configurableEnumIndex", {
  beginDrag(props) {
    return {
      id: props.enumValue.id,
      index: props.index
    };
  }
});
